<template>
  <div>
    <ContentSectionLoader v-show="!loaded" />
    <Transition name="fade">
      <div v-show="loaded">
        <DiscussionStats @loaded="discussionStatsLoaded = true" />
        <DiscussionCategoryList
          :show-loader="false"
          @loaded="discussionCategoriesLoaded = true"
        />
        <DiscussionList
          :per-page="5"
          :show-pagination="false"
          @loaded="discussionListLoaded = true"
        />
      </div>
    </Transition>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'Discussions',
  data() {
    return {
      discussionCategoriesLoaded: false,
      discussionStatsLoaded: false,
      discussionListLoaded: false,
    }
  },
  computed: {
    loaded() {
      return this.discussionCategoriesLoaded &&
        this.discussionStatsLoaded &&
        this.discussionListLoaded
    },
  },
}
</script>
